import { EMAIL_FRAGMENT } from '../fragments'
import gql from 'graphql-tag'


const FETCH_EMAIL = gql`
${EMAIL_FRAGMENT}
  query Email ($id: Int!) {
    email(id: $id) {
      ...email
    }
  }
`

const FETCH_EMAILS = gql`
  query emails ($siteId: Int!, $emailType: String, $limit: Int, $status: String) {
    emails(siteId: $siteId, emailType: $emailType, limit: $limit, status: $status)
    {
      id
      name
      subject
      preheader
      createdAt
    }
  }
`;

const FETCH_TEMPLATE = gql`
  query EmailTemplate ($id: Int!) {
    emailTemplate(id: $id) {
      id
      name
      json
      subject
      preheader
      tags
    }
  }
`;


export const GET_EMAIL_SUBJECT_AND_PREHEADER = gql`
  query EmailTemplate ($id: Int!) {
    emailTemplate(id: $id) {
      subject
      preheader
    }
  }
`;

const FETCH_TEMPLATES = gql`
  query EmailTemplates ($siteId: Int, $filterBy: EmailTemplateFilterInput, $sortBy: EmailTemplateSortBy, $cursor: cursorInput) {
    emailTemplates(siteId: $siteId, filterBy: $filterBy, sortBy: $sortBy, cursor: $cursor) {
      templates {
        id
        name
        position
        designFormat
        premium
        screenshotUrl
        tags,
        siteId
        live
        subject
        preheader
        utm
        plans
        direction
      }
      cursor {
        hasNextPage
      }
    }
  }
`

const FETCH_WEBSITE_TEMPLATE = gql`
  query EmailTemplateFeed ($filterBy: EmailTemplateFilterInput, $cursor: cursorInput) {
    emailTemplateFeed(filterBy: $filterBy, cursor: $cursor) {
      templates {
        id
        name
        position
        designFormat
        premium
        screenshotUrl
        tags,
        live,
        json
      }
      cursor {
        hasNextPage
      }
    }
  }
`

const FETCH_AI_TEMPLATES = gql`
  query EmailTemplates ($siteId: Int, $filterBy: EmailTemplateFilterInput, $sortBy: EmailTemplateSortBy, $cursor: cursorInput) {
    emailTemplates(siteId: $siteId, filterBy: $filterBy, sortBy: $sortBy, cursor: $cursor) {
      templates {
        id
        name
        screenshotUrl
        tags
        json
        subject
        preheader
      }
      cursor {
        hasNextPage
      }
    }
  }
`

const FETCH_EMAIL_ANALYTICS = gql`
  query emailAnalytics ($siteId: Int!, $id: Int!) {
    emailAnalytics(siteId: $siteId, id: $id) {
      activities
      browsers
      cities
      countries
      device_names
      devices
      links
      operating_systems
      routing_domains
      shopify_order_attributes
      shopifyOrderStats {
        salesTotalAmount
        totalSalesCount
      }
      stats
      isStatsCompleted
    }
  }
`

const FETCH_EMAIL_CLICKED_LINKS = gql`
  query clickheatmap ($siteId: Int!, $id: Int!) {
    emailAnalytics(siteId: $siteId, id: $id) {
      rawLinks
      stats
      isStatsCompleted
    }
  }
`

const FETCH_FILENAMES_FOR_DOWNLOADABLE_LINKS = gql`
  query fetchFileNamesForDownloadableLinks ($siteId: Int!, $linkHashes: [LinkHashesInput]) {
    fetchFileNamesForDownloadableLinks(siteId: $siteId, linkHashes: $linkHashes) {
      success
      fileNames {
        assetFileName
        linkId
      }
    }
  }
`

const FETCH_TOP_PERFORMING_EMAILS = gql`
  query topPerformingEmails ($siteId: Int!) {
    topPerformingEmails(siteId: $siteId) {
      id
      subject
      preheader
    }
  }
`

const FETCH_ORDER_NOTIFICATION_EMAIL = gql`
  query orderNotificationEmail ($siteId: Int!) {
    orderNotificationEmail (siteId: $siteId) {
      id,
      status,
      from,
      subject,
      preheader,
      json,
      body,
      siteId,
      fromName
    }
  }
`;

const FETCH_ADVANCED_EMAILS_ANALYTICS = gql`
  query advancedEmailsAnalytics ($siteId: Int!, $filter: JSON) {
    advancedEmailsAnalytics(siteId: $siteId, filter: $filter)
  }
`

const FETCH_ROUTING_DOMAIN_OPTIONS = gql`
  query routingDomainOptions ($siteId: Int!, $emailId: Int) {
    routingDomainOptions(siteId: $siteId, emailId: $emailId)
  }
`

export { 
  FETCH_EMAIL,
  FETCH_TEMPLATE,
  FETCH_TEMPLATES,
  FETCH_AI_TEMPLATES,
  FETCH_EMAIL_ANALYTICS,
  FETCH_FILENAMES_FOR_DOWNLOADABLE_LINKS,
  FETCH_EMAILS,
  FETCH_WEBSITE_TEMPLATE,
  FETCH_TOP_PERFORMING_EMAILS,
  FETCH_ORDER_NOTIFICATION_EMAIL,
  FETCH_ADVANCED_EMAILS_ANALYTICS,
  FETCH_ROUTING_DOMAIN_OPTIONS,
  FETCH_EMAIL_CLICKED_LINKS
}